import { render, staticRenderFns } from "./TopPaginator.vue?vue&type=template&id=5bcde250&scoped=true&"
import script from "./TopPaginator.vue?vue&type=script&lang=js&"
export * from "./TopPaginator.vue?vue&type=script&lang=js&"
import style0 from "./TopPaginator.vue?vue&type=style&index=0&id=5bcde250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcde250",
  null
  
)

export default component.exports